import { render } from "./HomeFooterButton.vue?vue&type=template&id=740b5b63&scoped=true"
import script from "./HomeFooterButton.vue?vue&type=script&lang=js"
export * from "./HomeFooterButton.vue?vue&type=script&lang=js"

import "./HomeFooterButton.vue?vue&type=style&index=0&id=740b5b63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740b5b63"]])

export default __exports__